import React, { useState } from 'react';
import { UserCheck, X } from 'lucide-react';
import { NominacionPuertaRequest } from '../../types/acreditacion.types';

interface NominacionPuertaModalProps {
  isOpen: boolean;
  codigoQr: string;
  onClose: () => void;
  onSubmit: (req: NominacionPuertaRequest) => void;
}

export const NominacionPuertaModal: React.FC<NominacionPuertaModalProps> = ({
  isOpen,
  codigoQr,
  onClose,
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    dni: '',
    email: ''
  });

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.nombre || !formData.apellido || !formData.dni) {
      alert('Por favor complete Nombre, Apellido y DNI.');
      return;
    }

    onSubmit({
      codigoQr,
      nombrePortador: formData.nombre.trim(),
      apellidoPortador: formData.apellido.trim(),
      dniPortador: formData.dni.trim(),
      emailPortador: formData.email.trim()
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brand-dark/90 backdrop-blur-md">
      <div className="card-blueprint rounded-3xl max-w-lg w-full p-6 sm:p-8 relative shadow-2xl border-brand-cyan/50">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 p-2 rounded-full bg-brand-surface text-slate-300 hover:text-white"
          aria-label="Cerrar modal"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex flex-col">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-brand-surface border border-brand-cyan/40 flex items-center justify-center text-brand-cyan">
              <UserCheck className="w-6 h-6" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white">Nominar Entrada en Puerta</h3>
              <p className="text-xs text-brand-sky font-mono">Código: {codigoQr}</p>
            </div>
          </div>

          <p className="text-xs text-slate-300 mb-6 leading-relaxed">
            Esta entrada es válida pero requiere asociarse a una persona antes de permitir el acceso.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-semibold text-slate-300 uppercase tracking-wider mb-1.5">
                  Nombre *
                </label>
                <input
                  type="text"
                  required
                  value={formData.nombre}
                  onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                  className="w-full px-3.5 py-2.5 rounded-xl bg-brand-dark border border-brand-cyan/30 text-white text-sm focus:border-brand-cyan focus:outline-none"
                  placeholder="Ej: Roberto"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-300 uppercase tracking-wider mb-1.5">
                  Apellido *
                </label>
                <input
                  type="text"
                  required
                  value={formData.apellido}
                  onChange={(e) => setFormData({ ...formData, apellido: e.target.value })}
                  className="w-full px-3.5 py-2.5 rounded-xl bg-brand-dark border border-brand-cyan/30 text-white text-sm focus:border-brand-cyan focus:outline-none"
                  placeholder="Ej: Gómez"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-semibold text-slate-300 uppercase tracking-wider mb-1.5">
                  DNI / Documento *
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  required
                  value={formData.dni}
                  onChange={(e) => setFormData({ ...formData, dni: e.target.value })}
                  className="w-full px-3.5 py-2.5 rounded-xl bg-brand-dark border border-brand-cyan/30 text-white text-sm focus:border-brand-cyan focus:outline-none"
                  placeholder="Ej: 30123456"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-300 uppercase tracking-wider mb-1.5">
                  Email
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-3.5 py-2.5 rounded-xl bg-brand-dark border border-brand-cyan/30 text-white text-sm focus:border-brand-cyan focus:outline-none"
                  placeholder="roberto@example.com"
                />
              </div>
            </div>

            <div className="pt-4 flex gap-3">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 py-3 rounded-xl bg-brand-surface text-slate-300 hover:text-white font-bold text-xs uppercase"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="flex-1 py-3 rounded-xl bg-brand-cyan hover:bg-brand-sky text-brand-dark font-heading font-extrabold text-xs uppercase shadow-glow-cyan"
              >
                Nominar y Acreditar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
